import { AxiosError } from 'axios';

import { getSessionContextUrl } from '../../utils/url';
import { axiosRetryDefault, sessionAxiosInstance as network } from '../axios';
import { GetSessionResponse } from '../types';

export const getSession = async () => {
  const path = getSessionContextUrl();

  const response = await network.get<GetSessionResponse>(path, {
    'axios-retry': {
      retryCondition: (error: AxiosError<any>) => {
        if (error.response?.status === 400) return true;
        return axiosRetryDefault(error);
      },
    },
  });

  return response.data;
};
